import { Component, OnInit, ViewChild, ElementRef, Inject, LOCALE_ID } from '@angular/core';
import { HttpService } from '../service/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../security/login.service';
import { Title } from '@angular/platform-browser';
import { LocaleService } from '../locale.service';
import { FaviconService } from '../favicon.service';
import { SimpleBrugesVndBooking } from '../simple-bruges-vnd-booking';
import { environment } from 'src/environments/environment';
import { EASYLANGUAGES_LOGO, LANGUESVIVANTES_LOGO } from '../logo-src-constants';
import { ApiErrorService } from '../api-error.service';
import { ApiError } from '../api-error';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  uuid!: string;
  booking!: SimpleBrugesVndBooking;
  failedToFindBooking!: boolean;

  pictureLoaded: boolean = false;
  fileToUpload: File | null = null;
  img: any;
  canvasBlob!: Blob | null;
  pictureUploaded: boolean = false;
  imageSent: boolean = false;
  pictureUploading: boolean = false;
  hasPicture: boolean = false;
  pictureUploadingError!: string | null;
  picturePostUrl!: string;
  lviLogo: string;

  @ViewChild("myCanvas", { read: ElementRef }) myCanvas!: ElementRef;
  context!: CanvasRenderingContext2D;

  constructor(
    private httpService: HttpService,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private titleService: Title,
    private localeService: LocaleService,
    // localId can be "fr", "nl", "en" or "es"
    @Inject(LOCALE_ID)
    public localeId: string,
    private faviconService: FaviconService,
    private apiErrorService: ApiErrorService,
    private router: Router
  ) {
    this.loginService.activatedNavigationComponent = false;
    if(this.localeId == "fr"){
      this.lviLogo = LANGUESVIVANTES_LOGO;
    } else {
      this.lviLogo = EASYLANGUAGES_LOGO;
    }
    this.titleService.setTitle(
      this.localeService.setTitleLanguage(this.localeId)
      );
     this.faviconService.lvi();
  }

  ngAfterViewInit() {
    this.context = (<HTMLCanvasElement>this.myCanvas.nativeElement).getContext("2d")!;
  }

  ngOnInit() {
    this.pictureLoaded = false;
    this.uuid = this.route.snapshot.paramMap.get("uuid")!;
    this.httpService.getBrugesVndBookingByUuid(this.uuid)
      .subscribe(booking => {
        this.booking = booking;
        if(this.booking.hasPicture){
          this.pictureLoaded = true;
          this.pictureUploaded = true;
        }
        this.picturePostUrl = environment.sbmsUrl + "/open/student-picture/" + booking.uuid;
      }, error => {
        if(error.status === 0){
          this.router.navigateByUrl("server-down");
          return;
        } else {
          this.apiErrorService.error = new ApiError(error);
          this.router.navigateByUrl("api-error");
        }
        this.failedToFindBooking = true;
        console.error(error);
      });
  }



  handleFileInput(event: any) {
    this.imageSent = false;
    if (event.files && event.files[0]) {
      this.fileToUpload = event.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(event.files[0]);
      reader.onload = (event: any) => {
        this.img = new Image();
        this.img.src = event.target.result;
        this.img.onload = () => {
          const sizeRatio = this.img.width / this.img.height;
          let resizedHeight = this.img.height;
          let resizedWidth = this.img.width;

          if (sizeRatio < 1 && 480 < this.img.height) {
            resizedHeight = 480;
            resizedWidth = 480 * sizeRatio;
          }
          if (sizeRatio >= 1 && this.img.width > 520) {
            resizedWidth = 520;
            resizedHeight = 520 / sizeRatio;
          }

          this.myCanvas.nativeElement.width = resizedWidth;
          this.myCanvas.nativeElement.height = resizedHeight;
          this.context.drawImage(this.img, 0, 0, resizedWidth, resizedHeight);
        }
        this.pictureLoaded = true;
      }
    }
  }

  uploadFile(files: File[]) {
    if(files.length == 0){
      return;
    }
    this.pictureUploading = true;
    this.pictureUploadingError = null;
    let formToSend = new FormData();

    try{
      formToSend.append("file", files[0]);
    }
    catch(error: any){
      this.pictureUploading = false;
      this.pictureUploadingError = error.message;
      return;
    }

    if(!formToSend.has("file")){
      this.pictureUploading = false;
      this.pictureUploadingError = "image file cannot be uploaded. please use modern brower such as Google Chrome or Firefox.";
      return;
    }

    this.httpService.postStudentPicture(formToSend, this.booking.uuid)
      .subscribe(() => {
        this.fileToUpload = null;
        this.pictureUploaded = true;
        this.imageSent = true;
        this.pictureUploading = false;
        this.context.clearRect(0, 0, this.myCanvas.nativeElement.width, this.myCanvas.nativeElement.height);
        this.hasPicture = false;
      },
        error => {
          if(error.status === 0){
            this.router.navigateByUrl("server-down");
            return;
          } else {
            this.apiErrorService.error = new ApiError(error);
            this.router.navigateByUrl("api-error");
          }
          console.error(error);
          this.pictureUploaded = false;
          this.fileToUpload = null;
          this.imageSent = false;
          this.pictureUploading = false;
          this.pictureUploadingError = error.error.message;
        }
      );
  }
}